import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./DetailTopUpInvUIHelpers";

const BillingUIContext = createContext();

export function useBillingUIContext() {
  return useContext(BillingUIContext);
}

export const BillingUIConsumer = BillingUIContext.Consumer;

export function BillingUIProvider({ billingUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initBilling = {
    name: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initBilling,
    newBillingIndividuButtonClick:
      billingUIEvents.newBillingIndividuButtonClick,
    openEditBillingIndividualPage:
      billingUIEvents.openEditBillingIndividualPage,
    openEditBillingOrganizationPage:
      billingUIEvents.openEditBillingOrganizationPage,
    openDeleteBillingPage: billingUIEvents.openDeleteBillingPage,
    newBillingOrganizationButtonClick:
      billingUIEvents.newBillingOrganizationButtonClick,
  };

  return (
    <BillingUIContext.Provider value={value}>
      {children}
    </BillingUIContext.Provider>
  );
}
